import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { useQuery } from "@tanstack/react-query";
import { searchApiService } from "../services/searchApiService";
import {
  fromSearchResponseDtoToSearchResponse,
  type SearchResponse,
} from "../types/searchTypes";

export const searchKeys = {
  all: ["search"] as const,
  list: (businessId: string | undefined, query: string) =>
    [...searchKeys.all, "list", businessId, query] as const,
};

export const useSearch = (query: string, enabled = true) => {
  const { businessId } = useCurrentBusiness();
  const searchQuery = query.trim();

  return useQuery<SearchResponse, Error>({
    queryKey: searchKeys.list(businessId, searchQuery),
    queryFn: async ({ signal }) => {
      if (!businessId) throw new Error("A business is required to search.");
      const dto = await searchApiService.getList(businessId, searchQuery, signal);
      return fromSearchResponseDtoToSearchResponse(dto);
    },
    enabled: enabled && !!businessId && searchQuery.length >= 2 && searchQuery.length <= 100,
  });
};
